import React from 'react';
import { inject, observer } from 'mobx-react';
import { computed, get } from 'mobx';
import { Table, Card } from 'sd-ui-components';
import { withRouter } from 'react-router-dom';
import FormattedDate from '../Common/FormattedDate';

const { Column } = Table;

@inject('EventsStore')
@inject('ObservationsStore')
@inject('ConfigStore')
@observer
class EventsList extends React.Component {
  @computed
  get eventsList() {
    const eventsList =
      get(
        this.props.EventsStore.eventsByObservationName,
        this.props.ObservationsStore.selectedObservationName
      ) || [];
    return this.props.EventsStore.sortEventsByRecordedDate(eventsList);
  }

  render() {
    return (
      <div>
        {this.props.EventsStore.loading.eventsList && <Card loading={true} />}

        {!this.props.EventsStore.loading.eventsList && (
          <Table
            dataSource={this.eventsList}
            rowKey="eventNumber"
            pagination={false}
            size="medium"
            className="events-events-table"
            onHeaderRow={() => ({
              className: 'events-events-table-header'
            })}
            onRow={record => ({
              className:
                'events-events-table-body linked sd-primary-color-5-border',
              onClick: () => {
                this.props.history.replace(
                  '/observation/' +
                    encodeURIComponent(
                      this.props.ObservationsStore.selectedObservationName
                    ) +
                    `/event/${encodeURIComponent(record.eventNumber)}`
                );
              }
            })}
          >
            <Column
              className="events-events-column-recorded"
              title="Recorded"
              dataIndex="recordedOn"
              key="recordedOn"
              render={(text, record) => (
                <span
                  data-automation-id={
                    'sd-ui-driver-events-recorded-column-' + record.eventNumber
                  }
                >
                  <FormattedDate
                    value={text}
                    day="2-digit"
                    month="2-digit"
                    hour="numeric"
                    minute="numeric"
                    timeZoneName="short"
                    timeZone={
                      record.siteIanaTimezone ||
                      this.props.ConfigStore.config.standardizedTimezone
                    }
                  />
                </span>
              )}
            />
            <Column
              className="events-events-column-event"
              title="Event"
              dataIndex="eventNumber"
              key="eventNumber"
              render={(eventNumber, record) => (
                <span
                  data-automation-id={
                    'sd-ui-driver-events-event-column-' + record.eventNumber
                  }
                >
                  {eventNumber}
                </span>
              )}
            />
            <Column
              className="events-events-column-score"
              title="Score"
              dataIndex="safetyScore"
              key="safetyScore"
              render={(safetyScore, record) => (
                <span
                  data-automation-id={
                    'sd-ui-driver-events-score-column-' + record.eventNumber
                  }
                >
                  {safetyScore}
                </span>
              )}
            />
          </Table>
        )}
      </div>
    );
  }
}

export default withRouter(EventsList);



// WEBPACK FOOTER //
// ./src/containers/Events/EventsList.jsx